module.exports = __webpack_public_path__ + "img/Y001.7b936329.jpg";